
import {PropType} from "vue";
import {RewardType} from "@/store/store.event.type";
import SvgIcon from "@/components/common/SvgIcon.vue";
import {getVICPrefixByMemberClub} from "@/utils/general";

export default {
  name: "RewardOverviewSingle",
  components: {SvgIcon},
  props: {
    item: {
      type: Object as PropType<RewardType>,
      required: true,
    },
  },
  setup() {

    return {
      getVICPrefixByMemberClub
    }
  }
}
